import { StyleSheet } from 'aphrodite';
import iconLink from '../../../assets/images/icon-link.svg';
import { defaultStyles, imagesUrl } from '../..';

const styles = StyleSheet.create({
    productWrapper: {
        border: '1px solid ' + defaultStyles.greyLight,
        backgroundColor: defaultStyles.white,
    },
    productWrapperResult: {
        border: 'none',
        backgroundColor: defaultStyles.greyBackground,
    },
    product: {
        display: 'flex',
        flexDirection: 'column',
        '@media screen and (min-width: 768px)': {
            flexDirection: 'row',
        },
        '@media print': {
            flexDirection: 'row',
            paddingTop: '0px',
        },
    },
    productContainer: {
        marginTop: '32px',
    },
    containerError: {
        border: '1px solid ' + defaultStyles.red,
    },
    error: {
        marginTop: '16px',
    },
    productResult: {
        border: 'none',
        backgroundColor: defaultStyles.greyBackground,
        '@media screen and (min-width: 768px)': {
            flexDirection: 'row',
            borderBottom: 'none',
        },
    },
    textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: '10px',
        '@media screen and (min-width: 768px)': {
            margin: '0',
            flexDirection: 'column',
            flexBasis: 'calc(100% - 200px)',
            justifyContent: 'space-between',
            padding: '32px',
        },
    },
    textWrapperResult: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '20px',
        '@media screen and (min-width: 768px)': {
            margin: '0',
            flexDirection: 'row',
            flexBasis: 'calc(100% - 200px)',
            justifyContent: 'space-between',
            padding: '0 0 0 20px',
        },
    },
    productTitleWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    productTitleWrapperResult :{
        display: 'block',
    },
    figure: {
        margin: '0',
        display: 'block',
        '@media screen and (min-width: 768px)': {
            margin: '20px 0 0 20px',
        },
    },
    figureResult: {
        margin: '0',
        '@media screen and (min-width: 768px)': {
            display: 'block',
        },
    },
    image: {
        width: '100%',
        maxWidth: '100%',
        '@media screen and (min-width: 768px)': {
            width: '200px',
        },
    },
    title: {
        display: 'inline-block',
        margin: '0',
        color: defaultStyles.greyTitle,
        fontSize: '24px',
        lineHeight: '30px',
        fontWeight: 'bold',
        minWidth: '80%',
    },
    productQuantity: {
        fontSize: '32px',
        lineHeight: '38px',
        color: defaultStyles.black,
        marginBottom: '20px'
    },
    productQuantitySpan: {
        fontWeight: 'bold',
        fontSize: '32px',
    },
    productQuantityMaj: {
        fontSize: '28px',
        textTransform: 'uppercase'
    },
    descriptionWrapper: {
        flexBasis: '70%',
        display: 'flex',
        flexDirection: 'column',
        '@media screen and (min-width: 990px)': {
            flexDirection: 'row',
        },
    },
    descriptionWrapperResult: {
        flexBasis: '50%',
    },
    description: {
        marginBottom: '20px',
        color: defaultStyles.greyText,
        flexBasis: '60%',
        '@media screen and (min-width: 990px)': {
            marginBottom: '0',
        },
    },
    certificate: {
        color: defaultStyles.greyText,
        flexBasis: '40%',
        '@media screen and (min-width: 990px)': {
            paddingLeft: '20px',
        },
    },
    productLinkWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    link: {
        display: 'inline-block',
        color: defaultStyles.blue,
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontSize: '16px',
        fontWeight: '700',
        marginTop: '1rem',
        position: 'relative',
        cursor: 'pointer',
        width: '100%',
        textAlign: 'center',
        '@media print': {
            display: 'none'
        },
        '@media screen and (min-width: 768px)': {
            width: 'auto',
        },
    },
    eye: {
        marginRight: '10px',
        transform: 'translateY(3px)',
    },
    linkProduct: {
        padding: '15px 20px',
        backgroundColor: defaultStyles.greyBackground,
        color: defaultStyles.black,
        transition: 'ease .3s',
        ':hover': {
            backgroundColor: defaultStyles.lightGrey,
        },
    },
    productDescriptionListTitle: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    relatedProductLink: {
        color: defaultStyles.darkBlue,
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'underline',
        },
    },
    backerRod: {
        margin: '0.5rem 0px 1rem',
        display: 'inline-block',
    },
    ButtonPrimary: {
        fontSize: '14px',
        fontWeight: '600',
        lineHeight: '1.29',
        display: 'inline-block',
        margin: '0',
        cursor: 'pointer',
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        wordBreak: 'break-word',
        position: 'relative',
        minHeight: '48px',
        padding: '15px 64px 15px 15px',
        transition: 'ease .2s',
        color: '#fff',
        backgroundColor: '#002063',
        marginTop: '20px',
        marginBottom: '20px',
        ':after': {
            display: 'none',
        },
        '@media screen and (min-width: 990px)': {
            marginBottom: '0',
        },
    },
    buttonArrow: {
        position: 'absolute',
        top: '0',
        right: '0',
        width: '48px',
        height: '100%',
        marginLeft: '16px',
        transition: 'ease .2s',
        backgroundColor: '#2d4691',
    },
    buttonArrowSvg: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '1rem',
        height: '1rem',
        transform: 'translateX(-50%) translateY(-50%)',
    },
    iconLinkInt: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.int + iconLink + ')',
        }
    },
    iconLinkQual: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.qual + iconLink + ')',
        }
    },
    iconLinkProd: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.prod + iconLink + ')',
        }
    },
    iconLinklocal: {
        ':after': {
            backgroundImage: 'url(' + imagesUrl.local + iconLink + ')',
        }
    },
    subtitle: {
        display: 'inline-block',
        margin: '0',
        color: defaultStyles.greyTitle,
        fontSize: '24px',
        lineHeight: '30px',
        fontWeight: '400',
        minWidth: '80%',
        marginLeft: '10px',
        marginBottom: '30px',
        paddingRight: '10px',
    },
    subsubtitle: {
        display: 'inline-block',
        margin: '0',
        color: defaultStyles.greyTitle,
        fontSize: '24px',
        lineHeight: '30px',
        fontWeight: '400',
        minWidth: '80%',
        marginLeft: '10px',
        marginBottom: '20px',
    },
    packagesContainer: {
        padding: '0',
        '@media screen and (min-width: 768px)': {
            padding: '0 20px',
        },
    },
    packagesFlexWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        '@media screen and (min-width: 768px)': {
            flexDirection: 'row',
        },
        '@media print': {
            flexDirection: 'row',
            paddingTop: '0px',
        },
        marginBottom: '30px',
    }
});

export default styles;
